<template>
  <div class="flex justify-between items-center py-4">
    <div class="flex flex-1 space-x-2 md:space-x-4 items-center">
      <img class="max-h-20" :src="`/sites/msd_gesundheit/themes/custom/melanoma/assets/quiz/fr/images/${$i18n.locale}/stop-melanom-logo-fr.svg`" alt="STOP MELANOM" />
      <span class="text-black font-bold text-2xl md:text-4xl">Quiz</span>
    </div>
    <div class="text-right flex-1">
      <img v-if="level" :src="`/sites/msd_gesundheit/themes/custom/melanoma/assets/quiz/fr/images/${$i18n.locale}/${level}-${score}.svg`" :alt="`${level}-${score}`" class="ml-auto" />
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusBar",
  props: {
    level: String,
    score: Number
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss"></style>
